import React from 'react'
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatNumberWithoutFractions } from '~/utils/helpers';

interface StarsChartProps {
  data: any
}

class CustomizedAxisTick extends React.Component {
  render() {
    //@ts-ignore
    const { x, y, index, fill } = this.props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor='middle' fill={fill}>
          {Array.from({ length: index + 1 }, (_, index) => '⭐️').join('')}
        </text>
      </g>
    );
  }
}

const StarsChart: React.FC<StarsChartProps> = ({ data }) => {
  const { t } = useTranslation()

  return <ResponsiveContainer width='100%' height={300}>
    <BarChart
      width={500}
      height={300}
      data={data?.map(value => ({
        name: t('{{value}} Stars', { value: formatNumberWithoutFractions(value.value) }),
        count: formatNumberWithoutFractions(value.count)
      }))}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray='3 3' />
      <XAxis dataKey='name' tick={<CustomizedAxisTick />} />
      <YAxis allowDecimals={false} />
      <Tooltip cursor={{ fill: 'transparent' }} />
      <Bar maxBarSize={35} dataKey='count' fill='#8884d8' />
    </BarChart>
  </ResponsiveContainer>
}
export default StarsChart